function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GLYPH_DICTIONARY, CUSTOMER_STATE, STATE_TRANSLATION_DICTIONARY } from '../../constants/customer.constants';
import { getEnumOrDefault } from 'invision-core/src/components/helpers/enum.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerLocaleKeys from '../../../../../src/locales/keys';
var SubscriberStateController = /*#__PURE__*/function () {
  function SubscriberStateController() {
    _classCallCheck(this, SubscriberStateController);
  }
  return _createClass(SubscriberStateController, [{
    key: "$onChanges",
    value: function $onChanges() {
      //The UI should never say "prospect lite" it should show as prospect for all intents and purposes
      this.state = this.state === CUSTOMER_STATE.PROSPECT_LITE ? CUSTOMER_STATE.PROSPECT : this.state;
      this.state = getEnumOrDefault(this.state, CUSTOMER_STATE, CUSTOMER_STATE.PROSPECT);
      this.stateTranslation = STATE_TRANSLATION_DICTIONARY[this.state];
      this.stateTranslationLowerCase = STATE_TRANSLATION_DICTIONARY[this.state].toLowerCase();
      this.stateClass = "is-".concat(this.stateTranslationLowerCase);
      this.stateGlyph = this.stateTranslationLowerCase in GLYPH_DICTIONARY && "status-".concat(GLYPH_DICTIONARY[this.stateTranslationLowerCase], "-filled");
      this.stateTitle = i18n.translate(CustomerLocaleKeys.SUBSCRIBER.STATE[this.stateTranslation]) || this.stateName;
    }
  }]);
}();
export default {
  template: require('./subscriber.state.template.html'),
  bindings: {
    state: '<',
    stateName: '<?'
  },
  controller: SubscriberStateController
};